import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const GatewaySection = ({ topOffset = '820vh' }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    gsap.fromTo(
      el.children,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.2,
        duration: 1.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 60%',
          toggleActions: 'play none none reverse',
        },
      }
    );
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{
        position: 'absolute',
        top: topOffset,
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '0 20px',
        pointerEvents: 'none',
      }}
    >
      <h2
        className="text-display"
        style={{
          maxWidth: '840px',
          marginBottom: '1.5rem',
          lineHeight: 1.15,
          fontSize: 'clamp(2.2rem, 5vw, 4.5rem)',
        }}
      >
        THERE IS ALWAYS SOMETHING NEW TO LAUNCH.
      </h2>
      <span
        style={{
          letterSpacing: '0.35em',
          fontWeight: 200,
          fontSize: 'clamp(1.2rem, 2vw, 1.6rem)',
          color: 'var(--text-muted)',
          marginBottom: '1rem',
          opacity: 0.7,
        }}
      >
        LAZPLAY
      </span>
      <p className="text-body" style={{ color: 'var(--text-secondary)', marginBottom: '3rem' }}>
        Games. Software. Everything you love to run.
      </p>
      <button
        className="glass-elevated"
        style={{
          padding: '18px 56px',
          color: 'var(--accent)',
          border: '1px solid var(--accent)',
          borderRadius: '100px',
          background: 'var(--glass)',
          cursor: 'pointer',
          pointerEvents: 'auto',
          fontSize: '1rem',
          fontWeight: 600,
          letterSpacing: '0.12em',
          boxShadow: '0 0 20px rgba(67, 221, 208, 0.25)',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.05)';
          e.currentTarget.style.boxShadow = '0 0 35px rgba(67, 221, 208, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 0 20px rgba(67, 221, 208, 0.25)';
        }}
      >
        ENTER LAZPLAY &rarr;
      </button>
    </section>
  );
};

export default GatewaySection;
